module.exports = __webpack_public_path__ + "static/media/tracker.3c71aab4.png";